<template>
  <div>
    <b-navbar v-if="!isHomePageRoute() || 1 == 1" style="height: auto !important;" fixed="top" toggleable="lg" class="navbar-static-top fixed-top">
      <b-navbar-brand @click="gotoAboutRedBagPage">
        <img src="~/assets/images/RedBag Logo with Radio White.png?text=RedBag" style="max-height:45px;" alt="RedBag">
      </b-navbar-brand>
    </b-navbar>
    <IncidentBanner v-if="isHomePageRoute()" />
    <div>
      <nuxt />
      <div v-if="isHomePageRoute() || 1==1" style="text-align:center;padding-bottom:1em;margin-top:1rem;">
        <b-button variant="danger" style="text-align:center;" @click="gotoAboutRedBagPage">
          Learn More About RedBag
        </b-button>
      </div>
      <PartnersCarousel v-if="isHomePageRoute()" />
    </div>
  </div>
</template>

<script>
// import BroadcastMessage from '~/components/BroadcastMessage.vue'
import { mapGetters, mapActions } from 'vuex'
import PartnersCarousel from '~/components/PartnersCarousel.vue'
import IncidentBanner from '~/components/incident/IncidentBanner.vue'

export default {
  components: {
    // BroadcastMessage,
    PartnersCarousel,
    IncidentBanner
  },
  data () {
    return {
      slide: 0,
      sliding: null,
      barcode: this.$route.params.barcode
    }
  },
  head () {
    return {
      bodyAttrs: {
        class: this.isHomePageRoute() ? 'dashboard-body' : 'test',
        style: 'padding-top: 90px;'
      }
    }
  },
  computed: {
    ...mapGetters('oidc', [
      'oidcUser'
    ])
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    isAboutPage () {
      // alert(this.$route.name)
      return (this.$route.name === 'redbag-barcode-about' || this.$route.name === 'redbag-about')
    },
    isHomePageRoute () {
      // alert(this.$route.name)
      return (this.$route.name === 'index')
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    gotoAboutRedBagPage () {
      // this.$router.push('/redbag/about')
      // this.$router.push('https://getredbag.com/')
      window.location.href = 'https://getredbag.com/'
    },
    ...mapActions('oidc', [
      'signOutOidc',
      'authenticateOidc'
    ])
  }
}
</script>

<style scoped>

.navbar-brand {
  margin-left: auto;
  margin-right: auto;
}

.navbar-logo{
  width:200px;
  height: 80px;
}

.back-button{
    display: flex;
    height: 40px;
}
/*
    Our blue:   #6588B1
    Our red:    #C73D3D
*/
/* Custom Css */
body {
    padding-top: 80px;
}

body.dashboard-body {
    padding-top: 0px;
}

.card-header-danger {
    background-color: #C73D3D !important;
    background: linear-gradient(60deg,#C73D3D,#C73D3D) !important;
    /*background: linear-gradient(60deg,#ef5350,#C73D3D);*/
}

.card-header-primary {
    background: linear-gradient(60deg,#436996,#6588b1) !important;
}

.carousel-inner img {
    margin: auto;
}

.btn-danger {
    background-color: #C73D3D;
}

.redbagTitle {
    font-weight: bold;
    color: #C73D3D;
}
.abs-center-x {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.redbagHeader{
    font-weight:bold;
    color:white;
    font-family: Calibri, sans-serif;
    font-size:xx-large;
    margin-left:10px;
    text-align:center;
}

.navbar {
    background-color: #C73D3D;
    text-align: center;
}

.navbar-light .navbar-nav .nav-link{
  color:white;
}

.navbar-redbag {
    background-color: #C73D3D;
    /*background: linear-gradient(60deg,#ef5350,#C73D3D) !important;*/
    text-align: center;
    height: 80px;
    color:white;
}

.hidden{
    display:none;
}

.notificationAnnouncement {
    background-color: #6588B1;
    padding:1rem;
    color:white;
    text-align:center;
    margin-bottom: 2rem;
}
/*
#broadcastMessage {
    background-color: #e9ecef;
    border-radius: 1rem 1rem 1rem 0rem;
    padding: 1rem;
}
*/
#broadcastContainer{
    margin-bottom:2rem;
}

.sponsor-container{
    height:100px;
}

.sponsor-container img {
    max-height:100px;
    max-width:100%;
}
        /*
.sponsor-container img {
    display: block;
    height: 100%;
    width: auto;
}
    */

#contact-us-overlay {
    color: #333;
    position: fixed;
    right: 10px;
    bottom: 0px;
    z-index: 1001;
}
    #contact-us-overlay a {
        color: #333;
        font-weight: bold;
    }

    #contact-us-overlay ul {
        margin: 40px 0px 0px 40px;
        padding: 0px;
        list-style: none;
    }

#contact-us-overlay li {
    float: left;
    margin-left: 8px;
    color: #333;
    background-color: #333;
    padding: 4px 4px 0px 4px;
    -webkit-border-radius: 10px 10px 0px 0px;
    -moz-border-radius: 10px 10px 0px 0px;
    border-radius: 10px 10px 0px 0px;
}

.contact-us-main .contact-us-inner {
    padding-left: 10px;
    font-size:x-large;
    background-image: none;
    background-position: 6px 7px;
    background-repeat: no-repeat;
}

.contact-us-inner {
    background-color: white;
    padding: 5px 8px 4px 8px;
    -webkit-border-radius: 8px 8px 0px 0px;
    -moz-border-radius: 8px 8px 0px 0px;
    border-radius: 8px 8px 0px 0px;
}
</style>
